import ReactDOM from "react-dom";
import { App } from "./components";

const container = document.getElementById("root");
ReactDOM.render(<App />, container);